/* eslint-disable no-undef */
import React, { Component } from "react";
import io from "socket.io-client";
import { subscribeSocket } from "../../utils/socketSubscribe";
import moment from "moment";
import mapStyle from "../../config/mapStyle";
import { socketURL } from "../../config";
// import { getHoursAndMinFromMillis } from "../../utils/common";
import Fetch from "../../utils/fetch";
import { getMarkerPath, createLatestRunner } from "../../utils/busMarkerRoute";
import visitedPoints from "../../images/pink_pin.png";

class Track extends Component {
  state = {
    loading: false,
    tripId: this.props.tripId
  };

  step = 0;

  async componentDidMount() {
    try {
      const socket = io(socketURL, {
        withCredentials: true,
        // server accepts WebSocket only (no long-polling) - see server/socket.js
        transports: ["websocket"]
      });
      subscribeSocket(socket, { tripIds: () => [this.props.tripId] });
      socket.on("locationData", this.handleTrackingData);

      this.initMap();
    } catch (err) {
      console.log(err);
    }
  }

  componentDidUpdate(prevProps) {
    console.log("Prev Props", prevProps);
    console.log("New Props", this.props);

    const isRefreshRequired = this.props.lastPoint !== prevProps.lastPoint;

    console.log("isRefreshRequired", isRefreshRequired);

    if (isRefreshRequired) {
      this.refreshMap();
    }
  }

  initMap = async () => {
    try {
      if (typeof google !== "undefined") {
        const { lastPoint = {}, savedLocation = [] } = this.props;

        const defaultMapCenter = {
          lat: 28.4595,
          lng: 77.0266
        };

        let mapCenter = defaultMapCenter;

        if (lastPoint.lat) {
          mapCenter = lastPoint;
        }

        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: 8,
          center: mapCenter,
          disableDefaultUI: true
        });

        // Add styles to Map
        const styledMapType = new google.maps.StyledMapType(mapStyle);
        this.map.mapTypes.set("styled_map", styledMapType);
        this.map.setMapTypeId("styled_map");

        // Adding Bus Marker
        if (lastPoint.lat) {
          this.createBusMarker();
        }

        if (savedLocation.length) {
          this.savedPointsMarker();
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  savedPointsMarker = () => {
    const { savedLocation = [] } = this.props;
    try {
      const savedLocationMarkers = [];

      for (let i = 0; i < savedLocation.length; ++i) {
        const point = savedLocation[i];

        let traveledPointMarker = new google.maps.Marker({
          position: { lat: point.lat, lng: point.lng },
          map: this.map,
          icon: visitedPoints
        });

        savedLocationMarkers.push(traveledPointMarker);

        const infoWindow = new google.maps.InfoWindow({
          content: `<p>Lat: ${point.lat}, Lng: ${point.lng}</p>
          <p>Time: ${moment(point.latlngDate).format("LLL")}</p>`
        });

        traveledPointMarker.addListener("click", () => {
          infoWindow.open(this.map, traveledPointMarker);
        });
      }

      this.savedLocationMarkers = savedLocationMarkers;
    } catch (err) {
      console.log(err);
    }
  };

  deleteSavedPointsMarker = () => {
    this.savedLocationMarkers.forEach(marker => marker.setMap(null));
    this.savedLocationMarkers = [];
  };

  refreshMap = async () => {
    // Delete bus Marker
    // Add new Bus marker
    // Delete Station Marker
    // Add new Station Marker
    try {
      this.deleteBusMarker();
      this.createBusMarker();
      this.deleteSavedPointsMarker();
      this.savedPointsMarker();
    } catch (err) {
      console.log(err);
    }
  };

  createBusMarker = () => {
    const { lastPoint = {} } = this.props;

    const busPosition = lastPoint;
    const lastLocationTime = moment(lastPoint.latlngDate).format("LLL");

    const busIcon =
      "M1.6,6.7V40c0,0.2,0,0.3,0,0.5c0,0.9,0.7,1.6,1.5,1.7c2.2,0.3,4.5,0.4,6.7,0.3c2.2,0.1,4.5-0.1,6.7-0.3   c0.9-0.1,1.6-0.8,1.6-1.7c0-0.1,0-0.3,0-0.4V6.8c0.1-1.2,0.1-2.3,0-3.5V3c-0.3-1.3-0.8-2.2-1.7-2.4C14.4,0.1,12.2,0,10.1,0H5.8   C5.1,0.1,4.4,0.2,3.7,0.4C2.8,0.6,2.3,1.5,2,2.9v0.2C1.8,4.3,1.6,5.5,1.6,6.7z M3.7,37.9c0,0.3-0.3,0.6-0.8,0.6s-0.8-0.2-0.8-0.6   V16.3c0-0.2,0.2-0.4,0.3-0.4c0.1-0.1,0.3-0.1,0.5,0c0.4,0,0.7,0.2,0.8,0.6L3.7,37.9z M15.7,39.8L15.7,39.8L15.2,40   c-2,0-4.1,0.2-6.1,0.2c-0.6,0-1.1,0-1.7,0H4.5c-0.2,0-0.3-0.1-0.4-0.2l0,0v-0.5c0.2,0,0.3,0,0.5,0h8.2c0.6,0,1.2,0,1.9,0   c0.4-0.1,0.9-0.1,1.3,0L15.7,39.8z M9.8,10c-2.1-0.1-4.2,0.1-6.2,0.4V11H3.3v-0.6l0,0C3.1,9,2.7,8,2.6,7l0,0c0-0.2,0-0.4,0-0.7   c0-0.3,0.1-0.5,0.3-0.7c0.3-0.2,0.7-0.4,1.2-0.3C6,4.9,8,4.7,10,4.8c1.9,0,3.8,0.2,5.7,0.6c0.4,0,0.7,0.2,1,0.4   c0.2,0.2,0.3,0.4,0.4,0.7v0.3c0,0.1,0,0.3,0,0.4c0,1-0.6,2-0.8,3.3v4.7h-0.2c-0.1-1.5-0.1-3.1,0-4.6c-2-0.4-4-0.5-6.1-0.6H9.8z    M6.3,0.7c0.2,0,0.4,0,0.5,0c1-0.1,2-0.2,3.1-0.2c1,0,2.1,0.1,3.1,0.2c0.2-0.1,0.3-0.1,0.5,0c0.1,0,0.2,0.1,0.2,0.2H12   c-0.7,0-1.3,0-2,0l0,0c-1.3,0-2.6,0.1-3.8,0.3C6.1,1.1,6.2,0.9,6.3,0.7L6.3,0.7z M17.8,38c0,0.3-0.4,0.6-0.8,0.6   c-0.4,0-0.7-0.2-0.8-0.6c0,0,0,0,0,0V16.3c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.4-0.2,0.6-0.2c0.5,0,0.8,0.3,0.8,0.6L17.8,38z M18,8.7   l-0.3,4.9c0,0.6-0.2,0.9-0.4,1h-0.5c-0.1-0.2-0.2-0.5-0.2-0.7v-1c-0.1-0.8-0.1-1.6,0-2.5L17,8.5c0-0.4,0-0.7,0.3-0.7h0.6   C18,8.1,18,8.4,18,8.7z M17.1,1.7c1,0.9,0.4,1.4-0.6,1.3l0,0c-0.2,0-0.4-0.1-0.6-0.2l-0.3-0.2l-0.3-0.3C15.1,2.2,15,2.1,14.9,2   c-0.3-0.3-0.6-0.7-0.7-1.2c0.3,0,0.6,0,0.9,0C15.8,0.9,16.5,1.2,17.1,1.7L17.1,1.7z M3.1,1.7c0.5-0.4,1-0.6,1.6-0.8   c0.4,0,0.8,0,1.2,0C5.7,1.6,4.5,3,3.7,3.1l0,0c-1.2,0-1.8-0.6-0.8-1.5L3.1,1.7z M2.1,7.9h0.3c0.2,0.2,0.3,0.5,0.3,0.7l0.4,1.9   c0.1,0.8,0.2,1.6,0.2,2.4v1c0,0.4,0,0.7-0.2,0.7H2.7c-0.2-0.3-0.4-0.6-0.4-1L1.9,8.8C1.9,8.3,1.9,7.9,2.1,7.9L2.1,7.9z M4.1,5.4   C6.1,4.9,8,4.7,10,4.8c1.9,0,3.8,0.2,5.7,0.6c0.4,0,0.7,0.2,1,0.4l0,0c-0.1-0.9-0.2-1.7-0.4-2.6l0,0c-0.2,0-0.4-0.1-0.6-0.2   l-0.3-0.2l-0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.6-0.7-0.8-1.2c0.3,0,0.6,0,0.9,0c-0.3,0-0.6,0-0.9,0l0,0   c-1.3-0.3-2.7-0.4-4-0.4H9.7c-1.3,0-2.7,0.1-4,0.4l0,0C5.4,1,5,1,4.6,1C5,1,5.4,1,5.8,1C5.6,1.6,4.4,3.1,3.6,3.2l0,0   C3.3,4,3.2,4.9,3.2,5.8l0,0C3.4,5.6,3.8,5.4,4.1,5.4L4.1,5.4z M6.3,0.9c0.2,0,0.4,0,0.5,0c1-0.1,2.1-0.2,3.1-0.2   c1,0,2.1,0.1,3.1,0.2c0.2-0.1,0.3-0.1,0.5,0c0.1,0,0.2,0.1,0.2,0.2h-1.8c-0.7,0-1.3,0-2,0l0,0c-1.3,0-2.6,0.1-3.8,0.3   C6.1,1.2,6.2,0.9,6.3,0.7V0.9z M17.9,7.9c0-0.1,0.1-0.3,0.2-0.3c0.2-0.1,0.4,0,0.7,0c0.2,0,0.4,0.1,0.6,0.2   c0.2,0.1,0.3,0.2,0.2,0.4c-0.1,0-0.1,0-0.2,0l-1.4-0.3L17.9,7.9 M17.9,7.9C17.8,8,17.6,8,17.5,7.8c-0.1-0.1-0.1-0.3,0-0.4   c0-0.2,0.6,0,0.8,0l0,0C18.3,7.5,18,7.7,17.9,7.9 M17.8,14.2v-0.5H18v0.8h-0.2L17.8,14.2L17.8,14.2z M14.6,39.3c-0.6,0-1.2,0-1.9,0   H16v0.5l0,0v-0.5C15.5,39.2,15,39.2,14.6,39.3L14.6,39.3z M15.4,40.1l0.3-0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-2.1,0.1-3.7,0.3-5.3,0.3   H9.2C11.2,40.4,13.2,40.2,15.4,40.1L15.4,40.1z M2,7.9H1.8L0.4,8.2c-0.1,0-0.2,0-0.2,0c0-0.2,0.1-0.4,0.2-0.4   c0.2-0.1,0.4-0.2,0.6-0.2h0.7C2.1,7.5,2,7.7,2,7.9 M2,7.8c0-0.1-0.1-0.2-0.2-0.3l0,0c0.3,0,0.8-0.2,0.8,0c0,0.1,0,0.2,0,0.3   c0,0.1-0.3,0-0.5,0 M2.2,14.3v0.3H1.9v-0.8h0.2L2.2,14.3 M10,0.4L10,0.4 M16.6,33V16.6l0,0V33 M16.6,16.6L16.6,16.6   c0-0.5,0-0.8,0.2-0.8l0,0V16c0,0.2,0,0.4,0,0.6L16.6,16.6z M17.2,15.9L17.2,15.9c0,0,0.2,0,0.3,0.3l0,0   C17.5,16,17.5,15.9,17.2,15.9 M17.5,16.2l0.3,1l0,0L17.5,16.2 M17.8,17.2L17.8,17.2c0.1,0.5,0.1,1,0,1.4l0,0   C17.9,18.2,17.9,17.7,17.8,17.2 M17.8,18.7v14.4l0,0V18.7 M16.3,24L16.3,24 M14.1,1.4L14.1,1.4c0.2,1.2,0.6,2.4,1.1,3.5l0,0   C14.7,3.8,14.4,2.6,14.1,1.4 M16.4,3L16.4,3c0.2,0.8,0.3,1.7,0.4,2.6c0,0.1,0,0.2,0,0.3l0,0c0-0.1,0-0.2,0-0.3   C16.8,4.7,16.7,3.8,16.4,3 M17.1,7L17.1,7 M3.3,16.6L3.3,16.6c0-0.2,0-0.4,0-0.6v-0.2l0,0V16.6z M2.7,15.9L2.7,15.9   c0,0-0.2,0-0.2,0.3l0,0C2.4,15.9,2.6,15.9,2.7,15.9 M2.4,16.2l-0.3,1l0,0L2.4,16.2 M2.2,17.2L2.2,17.2c-0.1,0.5-0.1,1,0,1.4l0,0   c0-0.5,0-1,0.2-1.4 M2.3,18.7v14.4l0,0V18.7 M3.6,24L3.6,24 M5.8,1.4L5.8,1.4C5.5,2.6,5.2,3.8,4.7,4.9l0,0C5.2,3.8,5.5,2.6,5.8,1.4    M3.4,3L3.4,3C3.2,3.8,3.1,4.7,3,5.6v0.3l0,0V5.6C3.1,4.7,3.2,3.8,3.4,3 M1.6,7.1h1.1 M1.6,7.1h1.1 M5.6,1.2L5.6,1.2   C7,0.9,8.4,0.8,9.8,0.8l0,0C8.4,0.8,7,0.9,5.6,1.2z M2.7,20.7h0.1 M2.8,17.8L2.8,17.8 M2.8,23.6L2.8,23.6 M2.8,26.6H2.3v-0.1h0.5    M2.8,29.4L2.8,29.4 M2.8,32.3L2.8,32.3 M16.8,20.6L16.8,20.6 M16.7,17.7L16.7,17.7 M16.7,23.5L16.7,23.5 M16.7,26.5L16.7,26.5    M16.7,29.4L16.7,29.4 M16.7,32.3L16.7,32.3";

    const icon = {
      path: busIcon,
      scale: 0.7,
      strokeColor: "white",
      strokeWeight: 0.1,
      fillOpacity: 1,
      fillColor: "#7b2aff",
      anchor: new google.maps.Point(7, 15) // 0,0 origin 14,31 back of car, 14,0 front of car, 7,15 center of car
    };

    const busMarker = new google.maps.Marker({
      position: busPosition,
      map: this.map,
      icon,
      animation: google.maps.Animation.DROP,
      title: `${lastLocationTime}`,
      optimized: false,
      zIndex: 100
    });

    const infoWindow = new google.maps.InfoWindow({
      content: `<p><b>Last Location Time: ${lastLocationTime}</b></p>`
    });

    busMarker.addListener("click", () => {
      infoWindow.open(this.map, busMarker);
    });

    this.busMarker = busMarker;
    this.icon = icon;

    return;
  };

  deleteBusMarker = () => {
    this.busMarker.setMap(null);
    this.busMarker = null;
  };

  getDirections = async (startPoint, endPoint, path = []) => {
    const url = `/bus-tracker/routeOSRM`;
    const options = {
      method: "post",
      data: {
        startPoint,
        endPoint,
        path
      }
    };
    const response = await Fetch(url, options);
    return response;
  };

  getRoute = async (startPoint, endPoint, path = []) => {
    let route = await this.getDirections(startPoint, endPoint, path);
    return route;
  };

  runBusMove = createLatestRunner();

  handleTrackingData = data => {
    if (data && data.tripId === this.props.tripId) {
      this.runBusMove("locationData", () => this.updateBusLocation(data));
    }
  };

  updateBusLocation = async data => {
    const { tripId } = this.props;

    if (data && data.tripId === tripId) {
      console.log(data);
      this.breakDown = 0;
      this.step = 0;

      const busMarker = this.busMarker;

      const latPosition = busMarker.getPosition().lat();
      const lngPosition = busMarker.getPosition().lng();

      const startPoint = {
        coordinates: { lat: latPosition, lng: lngPosition }
      };
      const route = await getMarkerPath(
        startPoint.coordinates,
        data.coordinates
      );

      this.path = route;

      const date = moment(+data.body[0].latlngDate).format("LLL");

      busMarker.setTitle(`${date}`);

      if (this.path.length && this.path.length < 50) {
        console.log("Move marker");
        requestAnimationFrame(this.moveMarker);
      } else {
        console.log("Jump marker");
        const { lat, lng } = data.coordinates;
        this.jumpMarker(lat, lng);
      }
    }
  };

  moveMarker = () => {
    if (this.step < this.path.length) {
      const busMarker = this.busMarker;
      const map = this.map;
      const icon = this.icon;

      const latPosition = busMarker.getPosition().lat();
      const lngPosition = busMarker.getPosition().lng();

      const nextPosition = this.path[this.step];
      const newLatPosition = nextPosition.lat;
      const newLngPosition = nextPosition.lng;

      const oldPosition = new google.maps.LatLng(latPosition, lngPosition);
      const newPosition = new google.maps.LatLng(
        newLatPosition,
        newLngPosition
      );

      const angle = google.maps.geometry.spherical.computeHeading(
        oldPosition,
        newPosition
      );

      busMarker.setPosition(newPosition);

      icon.rotation = angle;
      busMarker.setIcon(icon);

      map.panTo(newPosition);

      this.step += 1;
      requestAnimationFrame(this.moveMarker);
    }
  };

  jumpMarker = (latPosition, lngPosition) => {
    const busMarker = this.busMarker;
    const map = this.map;
    const icon = this.icon;

    const oldLatPosition = busMarker.getPosition().lat();
    const oldLngPosition = busMarker.getPosition().lng();

    const oldPosition = new google.maps.LatLng(oldLatPosition, oldLngPosition);
    const newPosition = new google.maps.LatLng(latPosition, lngPosition);

    const angle = google.maps.geometry.spherical.computeHeading(
      oldPosition,
      newPosition
    );

    busMarker.setPosition(newPosition);

    icon.rotation = angle;
    busMarker.setIcon(icon);

    map.panTo(newPosition);
  };

  render() {
    const { loading } = this.state;
    const { width = "100%", height = "100vh" } = this.props;

    return loading ? (
      <h1>Loading ....</h1>
    ) : (
      <div style={{ width, height }} id="map" />
    );
  }
}

export default Track;
